import React, { useState, useCallback, useEffect, useRef } from "react";
import {
  Page,
  Card,
  PageActions,
  Text,
  Loading,
  Checkbox,
  FormLayout,
  TextField,
  InlineError,
  Toast,
  Button,
  Form,
  DropZone,
  Stack,
  Thumbnail,
  BlockStack,
  Modal,
  Spinner,
} from "@shopify/polaris";
import axios from "../../Assets/Lib/axios";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { NoteIcon } from "@shopify/polaris-icons";
import LoadingScreen from "../../Components/LoadingScreen";
import EllipsisText from "react-ellipsis-text";
import { Editor } from "@tinymce/tinymce-react";

const AddEditBanner = (props) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [isSaving, setIsSaving] = useState(
    props.type === "edit" ? true : false
  );
  const [isImageUploading, setIsImageUploading] = useState(false);
  const [imagePreview, setImagePreview] = useState("");
  const [item, setItem] = useState({
    image: "",
    imageAr: "",
    isActive: true,
  });
  const handleChangeNameEn = (newValue) => {
    setItem({ ...item, nameEn: newValue });
    setNameEnError("");
  };
  const [nameEnError, setNameEnError] = useState("");
  const handleChangeNameAr = (newValue) => {
    setItem({ ...item, nameAr: newValue });
    setNameArError("");
  };
  const [nameArError, setNameArError] = useState("");
  const handleChangeActive = (newValue) => {
    setItem({ ...item, isActive: newValue });
  };
  const [files, setFiles] = useState([]);
  const handleDropZoneDrop = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFiles((files) => [...files, ...acceptedFiles]),
    []
  );

  const validImageTypes = ["image/gif", "image/jpeg", "image/png"];

  const fileUpload = !files.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs (Required size: 1820x480 pixels)"}
    />
  );
  const uploadedFiles = files.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(files[files.length - 1].type)
              ? window.URL.createObjectURL(files[files.length - 1])
              : NoteIcon
          }
        />
        <div>
          {files[files.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {files[files.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );

  const [filesAr, setFilesAr] = useState([]);
  const handleDropZoneDropAr = useCallback(
    (_dropFiles, acceptedFiles, _rejectedFiles) =>
      setFilesAr((filesAr) => [...filesAr, ...acceptedFiles]),
    []
  );

  const fileUploadAr = !filesAr.length && (
    <DropZone.FileUpload
      actionHint={"Accepts pngs and jpegs (Required size: 1820x480 pixels)"}
    />
  );
  const uploadedFilesAr = filesAr.length > 0 && (
    <div style={{ padding: "0" }}>
      <div className="rowDiv">
        <Thumbnail
          size="small"
          source={
            validImageTypes.includes(filesAr[filesAr.length - 1].type)
              ? window.URL.createObjectURL(filesAr[filesAr.length - 1])
              : NoteIcon
          }
        />
        <div>
          {filesAr[filesAr.length - 1].name}{" "}
          <Text variant="bodySm" as="p">
            {filesAr[filesAr.length - 1].size} bytes
          </Text>
        </div>
      </div>
    </div>
  );
  const [imageError, setImageError] = useState("");
  const [active, setActive] = useState(false);
  const toggleActive = useCallback(() => setActive((active) => !active), []);
  const toastMarkup = active ? (
    <Toast
      content="Changes have been saved successfully"
      onDismiss={toggleActive}
    />
  ) : null;

  const imageKey = useRef("");
  const sendImage = (files) => {
    setItem({
      ...item,
      image:
        validImageTypes.indexOf(files[files.length - 1].type) > 0
          ? window.URL.createObjectURL(files[files.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  const sendImageAr = (filesAr) => {
    setItem({
      ...item,
      imageAr:
        validImageTypes.indexOf(filesAr[filesAr.length - 1].type) > 0
          ? window.URL.createObjectURL(filesAr[filesAr.length - 1])
          : "https://cdn.shopify.com/s/files/1/0757/9955/files/New_Post.png?12678548500147524304",
    });
    setImageError("");
  };
  useEffect(() => {
    props.type === "edit" &&
      axios
        .get(`/banners/${id}`)
        .then((result) => {
          console.log(result.data.data);
          setItem({
            image: result?.data?.data?.image?.en
              ? result.data.data.image.en
              : "",
            imageAr: result?.data?.data?.image?.ar
              ? result.data.data.image.ar
              : "",
            isActive: result?.data?.data?.is_active ? true : false,
          });
          setIsSaving(false);
        })

        .catch((err) => console.log(err));
  }, []);

  const refId = useRef(null);
  const [activeDelete, setActiveDelete] = useState(false);
  const handleChangeModalDelete = useCallback((activeDelete) => {
    setActiveDelete(!activeDelete);
    setIsSaving(false);
  }, []);
  const handleDelete = (id) => {
    refId.current = id;
    setActiveDelete(true);
  };
  const handleYesDelete = () => {
    setIsSaving(true);
    axios
      .delete(`/banners/${id}`)
      .then((result) => {
        navigate("/admin/banners");
      })
      .catch((err) => console.log(err));
  };
  return (
    <Page
      title={`${props.type === "add" ? "Add" : "Edit"} Banner`}
      backAction={{ onAction: () => navigate("/admin/banners") }}
      narrowWidth
    >
      {isSaving ? <Loading /> : null}

      <Card sectioned>
        <FormLayout>
          <Text>
            Image En <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail size="large" source={item.image ? item.image : ""} />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpg,.jpeg"
                onDrop={handleDropZoneDrop}
                allowMultiple={false}
                onDropAccepted={sendImage}
              >
                {uploadedFiles}
                {fileUpload}
              </DropZone>
            </div>
          </div>
          <Text>
            Image Ar <span style={{ color: "#8e1f0b" }}>*</span>
          </Text>

          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "row",
            }}
          >
            <div>
              <Thumbnail
                size="large"
                source={item.imageAr ? item.imageAr : ""}
              />
            </div>
            <div
              style={{
                width: "100%",
                marginLeft: "10px",
              }}
            >
              <DropZone
                accept=".png,.jpg,.jpeg"
                onDrop={handleDropZoneDropAr}
                allowMultiple={false}
                onDropAccepted={sendImageAr}
              >
                {uploadedFilesAr}
                {fileUploadAr}
              </DropZone>
            </div>
          </div>
          <InlineError message={imageError} />

          <Checkbox
            label="Is active"
            checked={item.isActive}
            onChange={handleChangeActive}
          />
        </FormLayout>
      </Card>

      <PageActions
        primaryAction={
          <Button variant="primary" onClick={handleSave}>
            {isSaving ? <Spinner size="small" /> : "Save"}
          </Button>
        }
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              tone="critical"
              onClick={() => setActiveDelete(true)}
            >
              {isSaving ? <Spinner size="small" /> : "Delete"}
            </Button>
          )
        }
      />

      {/* <PageActions
        primaryAction={{
          content: "Save",
          onClick: handleSave,
          loading: isSaving && true,
        }}
        secondaryActions={
          props.type === "edit" && (
            <Button
              variant="primary"
              loading={isSaving}
              tone="critical"
              onClick={() => {
                setIsSaving(true);
                axios
                  .delete(`/universities/${id}`)
                  .then((result) => {
                    navigate("/admin/universities");
                  })
                  .catch((err) => console.log(err));
              }}
            >
              Delete
            </Button>
          )
        }
      /> */}
      <Modal
        open={activeDelete}
        onClose={handleChangeModalDelete}
        title="Delete Item"
        primaryAction={{
          content: "Yes",
          onAction: handleYesDelete,
          loading: isSaving,
        }}
        secondaryActions={[
          {
            content: "No",
            loading: isSaving,
            onAction: handleChangeModalDelete,
          },
        ]}
      >
        <Modal.Section>
          <Text>
            <p>Are you sure you want to delete this item?</p>
          </Text>
        </Modal.Section>
      </Modal>
      {toastMarkup}
      {isImageUploading ? <LoadingScreen /> : null}
    </Page>
  );

  function handleSave() {
    if (props?.type === "add" && !files?.length && !filesAr.length) {
      props?.type === "add" &&
        !files?.length &&
        !filesAr.length &&
        setImageError("Please upload an image");
    } else {
      setIsSaving(true);
      const form_data = new FormData();

      files?.length && form_data.append("image[en]", files[0]);
      filesAr?.length && form_data.append("image[ar]", filesAr[0]);
      form_data.append("is_active", item.isActive ? 1 : 0);
      props?.type === "edit" && form_data.append("_method", "PATCH");
      props.type === "add"
        ? axios
            .post(`/banners`, form_data)
            .then((result) => {
              navigate("/admin/banners");
            })
            .catch((err) => console.log(err))
        : axios
            .post(`/banners/${id}`, form_data)
            .then((result) => {
              navigate("/admin/banners");
              // toggleActive();
              // setIsSaving(false);
            })
            .catch((err) => console.log(err));
    }
  }
};

export default AddEditBanner;
